export default "__VITE_ASSET__B7I8YjxS__"